/**
 * Generates a client-side-only correlation identifier, created once per app
 * mount. Used as a fallback correlation ID for the edge case where an error
 * occurs before any backend-derived `sessionId`/`callId` exists yet
 *
 * Implemented as a small standalone RFC4122 v4 UUID generator (rather than
 * pulling in the `uuid` package) since it only needs to be unique per app
 * mount, not cryptographically unguessable, and this keeps the module
 * dependency-free and trivially bundlable/testable across environments.
 */
export const generateClientJourneyId = (): string =>
  "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0;
    const value = char === "x" ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
